import React from "react";

const Card = ({ beach, toggleFavorite, favorites }) => {
  const isFavorite = favorites.includes(beach.name);
  const bgColor = "bg-[#fbfcf5]";

  const getTemperatureColor = (tempTime) => {
    const now = new Date();
    const measurementDate = new Date(tempTime);
    const diffInHours = (now - measurementDate) / (1000 * 60 * 60);

    if (diffInHours < 24) {
      return "text-[#000000]"; // Dark
    } else if (diffInHours < 7 * 24) {
      return "text-[#333333]"; // Darker
    } else if (diffInHours < 30 * 24) {
      return "text-[#777777]"; // Pale
    } else {
      return "text-[#BBBBBB]"; // Really pale
    }
  };

  const temperatureColor = getTemperatureColor(beach.temp_time);
  return (
    <div
      key={beach.name}
      className={`beach-card ${bgColor} rounded-[12px] p-4 my-4 max-w-[600px] mx-auto cursor-pointer text-left relative`}
    >
      <div className="flex justify-between items-center">
        <div className="flex-column items-center">
          <div className="flex items-center">
            <button
              onClick={() => toggleFavorite(beach.name)}
              className="bg-none border-none cursor-pointer text-[1.5em] pr-1"
            >
              {isFavorite ? "💚" : "♡"}
            </button>
            <h2 className="text-[1em] m-0 text-[#333]">{beach.name}</h2>
          </div>
          <p className="measured-at text-[0.8em] my-1 text-[#777]">
            {new Date(beach.temp_time).toLocaleString()}
          </p>
          {beach.status === "1" && (
            <p className="status text-[0.8em] my-1 text-[#777]">Ei sinilevää</p>
          )}
        </div>
        <p className={`temperature text-[3em] m-0 ${temperatureColor}`}>
          {beach.temperature}°
        </p>
      </div>
    </div>
  );
};

export default Card;
